import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import styles from './Badge.module.css';

const bindClasses = classNameBind.bind(styles);

const Badge = ({ text, disabled, size, color, display, iconLeft, iconRight }) => (
  <div
    className={bindClasses('wrapper', size, color, { disabled })}
    data-ppuc-id="Badge"
    style={{ display }}
  >
    <div className={bindClasses('innerBadge')}>
      {iconLeft && <div className={bindClasses('icon-left')}><Icon {...iconLeft} /></div>}
      <div className={bindClasses('text')}>
        {text}
      </div>
      {iconRight && <div className={bindClasses('icon-right')}><Icon {...iconRight} /></div>}
    </div>
  </div>
);

Badge.defaultProps = {
  disabled: false,
  size: 'large',
  color: 'black',
  display: 'inline-block',
};

export default Badge;
